import * as Yup from "yup";
import valid from "card-validator";

const errors = window.post_template?.checkout_v4_form?.checkout_v4_errors;
const requiredError = errors?.tr_checkout_v4_form_requiredError;
const cardError = errors?.tr_checkout_v4_form_cardError;
const expirationError = errors?.tr_checkout_v4_form_expirationError;
const emailError = errors?.tr_checkout_v4_form_emailError;
const phoneError = errors?.tr_checkout_v4_form_phoneError;
const cvvError = errors?.tr_checkout_v4_form_cvvError;
const policyError = errors?.tr_checkout_v4_form_termsError;
const symbolError = errors?.tr_checkout_v4_form_symbolError;

const isExpirationValid = (month, year) => {
  if (!month || !year) return false;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const expYear = parseInt(year);
  const expMonth = parseInt(month);

  if (expYear < currentYear) return false;

  if (expYear === currentYear && expMonth < currentMonth) return false;

  return expYear <= currentYear + 10;
};

const newRegex =
  /^(?:[\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0400-\u04FF\u4E00-\u9FFF\u0600-\u06FF])+$/u;

const strictStructureRegex = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(emailError)
    .matches(strictStructureRegex, emailError)
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),

  phone: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
      return schema
        .test("phoneValidTest", phoneError, (value) => {
          const input = document.querySelector(".iti__tel-input");
          const iti = window.intlTelInputGlobals.getInstance(input);

          return iti.isValidNumber();
        })
        .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
        .required(requiredError);
    }
  }),

  first_name: Yup.string()
    .matches(/^\D*$/, symbolError)
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),

  last_name: Yup.string()
    .matches(/^\D*$/, symbolError)
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),

  address: Yup.string()
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),

  country: Yup.string()
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      const t = type?.[0] || {};
      if (t.method === "card" || t.method === "klarna" || t.paypalHandler === "wr") {
        return schema.required(requiredError);
      }
      return schema;
    }),

  state: Yup.string()
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),

  zip: Yup.string()
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),

  city: Yup.string()
    .test("symbolValidTest", symbolError, (value) => !value || newRegex.test(value))
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].method == "klarna" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),

  card_name: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].method == "klarna") {
      return schema.required(requiredError);
    }
  }),

  card_number: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema
        .test("test-cardNumb", cardError, (value) => {
          const cardInfo = valid.number(value);
          return (
            cardInfo.isValid ||
            value == "0000 0000 0000 0000" ||
            value == "0000 0000 0111 1111" ||
            value == "7111 1111 1110 0000"
          );
        })
        .required(requiredError);
    }
  }),

  card_cvc: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema
        .test("test-cvvNumb", cvvError, (value, schema) => {
          const card_number = schema?.from[0]?.value?.card_number;
          const cvvLength = valid.number(card_number).card?.code?.size;
          return valid.cvv(value, cvvLength).isValid || schema?.from[0]?.value?.card_number == "0000 0000 0000 0000";
        })
        .required(requiredError);
    }
  }),

  card_exp_year: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema.required(requiredError).test("test-exp_year", expirationError, function (value) {
        if (!valid.expirationYear(value).isValid) return false;

        const month = this.parent.card_exp_month;
        return isExpirationValid(month, value);
      });
    }
  }),

  card_exp_month: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema.required(requiredError).test("test-exp_month", expirationError, function (value) {
        if (!valid.expirationMonth(value).isValid) return false;

        const year = this.parent.card_exp_year;
        return isExpirationValid(value, year);
      });
    }
  }),

  policy: Yup.bool().when("$type", (type, schema) => {
    if (type[0].safe === true) {
      return schema.oneOf([true], policyError).required(requiredError);
    }
  }),
});

export { validationSchema };
